module.exports = __webpack_public_path__ + "img/aer-pampa.6b6ab3f8.jpg";